import { render, staticRenderFns } from "./contact-us.vue?vue&type=template&id=fe64fc28&scoped=true&lang=pug"
import script from "./contact-us.js?vue&type=script&lang=js&external"
export * from "./contact-us.js?vue&type=script&lang=js&external"
import style0 from "./contact-us.vue?vue&type=style&index=0&id=fe64fc28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe64fc28",
  null
  
)

export default component.exports